import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {map, Observable, startWith, switchMap} from 'rxjs';
import {IdentityRoleDto} from '../role-data/models/RoleDtos';
import {UserRoleService} from './user-role.service';
import {FormControl} from '@angular/forms';
import {IdentityUserUpdateRolesDto} from '../user-role-data/models/UserRoleDtos';
import {IdentityUserDto} from '../user-data/models/UserDtos';
import {DialogService} from "../shared/dialog/dialog.service";
import {MasterDetailHub} from "../shared/master-detail/master-detail-hub.service";

@Component({
    selector: 'cml-user-role',
    templateUrl: './user-role.component.html',
    styleUrls: ['./user-role.component.scss'],
    standalone: false
})
export class UserRoleComponent implements OnInit {
  private entityId: string = "";

  roles: IdentityRoleDto[] = [];

  filteredRoles$: Observable<IdentityRoleDto[]> | undefined;

  user: IdentityUserDto | undefined;

  myControl = new FormControl();

  initialized: boolean = false;

  buttons: any;

  @ViewChild('input')
  input: ElementRef | undefined;

  constructor(private router: Router, private route: ActivatedRoute, private userRoleService: UserRoleService, protected dialogService: DialogService, protected masterDetailHub: MasterDetailHub) {
    this.entityId = this.route.snapshot.params['id'];
    this.buttons = userRoleService.createToolbarButtons();
    this.userRoleService.component = this;
  }

  ngOnInit(): void {
    this.initialise();
  }

  async invoke(method: Exclude<keyof UserRoleComponent, "invoke">) {
    await this[method]();
  }

  async initialise() {
    let result = await this.userRoleService.get(this.entityId);
    if (result) {
      this.roles = Object.assign([], result);
    }
    this.filteredRoles$ = this.myControl.valueChanges
      .pipe(
        startWith(''),
        switchMap(value => (value ? this._filterRoles(value) : this.getRoles()))
      );
    this.initialized = true;
    this.user = await this.userRoleService.getUser(this.entityId);
  }

  getRoles(): Observable<IdentityRoleDto[]> {
    return this.userRoleService.getRoles().pipe(
      map((els: IdentityRoleDto[]) => els.filter(el => this.roles.findIndex(x => x.name === el.name) === -1))
    );
  }

  onSelect(selected: any) {
    this.getRoles().pipe(map((els: IdentityRoleDto[]) => els.filter(el => el.name === selected)[0]))
      .subscribe(role => {
        this.roles.push(role);
        if (this.input) {
          this.myControl.setValue('');
        }
      });
  }

  removeRole(role: IdentityRoleDto) {
    this.roles.splice(this.roles.indexOf(role), 1);
    this.myControl.setValue(this.myControl.value);
  }

  navigateToDetail() {
    this.router.navigateByUrl(this.router.url.replace(/\/roles$/g, ''));
  }

  async save() {
    let entityToEdit = new IdentityUserUpdateRolesDto();
    entityToEdit.roleNames = this.roles.map(x => x.name);
    await this.userRoleService.edit(this.entityId, entityToEdit);
    this.masterDetailHub.emitRefresh();
  }

  close(){
    this.router.navigateByUrl(this.route.snapshot.data["basePath"]);
  }

  private _filterRoles(value: string): Observable<IdentityRoleDto[]> {
    const filterValue = value.toLowerCase();
    return this.getRoles().pipe(map((els: IdentityRoleDto[]) => els.filter(el => el.name.toLocaleLowerCase().includes(filterValue))));
  }
}
